import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WorkFlowService {
  apiUrl = environment.API_SERVER;
  organizationUnitId = 'ncc';
  workFlowGroups: BehaviorSubject<Array<any>> = new BehaviorSubject([]);

  workflows = () =>
    `${this.apiUrl}/collaborators/${this.organizationUnitId}/work_flows/`;
  workflowtype = (workflowId, type) =>
    `${this.workflows()}work_flows/${workflowId}/type/${type}/`;
  users = (workflowId, type) => `${this.workflowtype(workflowId, type)}users/`;

  addWorkFlowGroup(collaborators) {
    let wf: any = this.workFlowGroups.value;
    wf.push(collaborators);
    this.workFlowGroups.next(wf);
  }

  deleteWorkFlowGroup(i) {
    let wf: Array<any> = this.workFlowGroups.value;
    wf.splice(i, 1);
    this.workFlowGroups.next(wf);
  }

  editWorkFlowGroup(i, collaborators) {
    let wf: Array<any> = this.workFlowGroups.value;
    let count = 0;
    wf = wf.map((e) => {
      if (count == i) {
        e = collaborators;
      }
      return e;
    });
    this.workFlowGroups.next(wf);
  }

  constructor(private _httpClient: HttpClient) {}

  getWorkflows(payload): Observable<any> {
    const url = `${this.apiUrl}/collaborators/${payload.organizationUnitId}/work_flows/`;
    return this._httpClient.get(url, { params: payload.params });
  }
  getAllAppUsers(payload): Observable<any> {
    const url = `${this.apiUrl}/admin/ncc_app_users/`;
    return this._httpClient.get(url, { params: payload.params });
  }
  getAllUsers2(payload) {
    const url = `${this.apiUrl}/admin/ncc_app_users_v2`;
    return this._httpClient.get(url, { params: payload.params });
  }

  getNewEndpointAppUsers(payload): Observable<any> {
    const url = `${this.apiUrl}/chat/users/subtopic/assignable/`;
    return this._httpClient.get(url, { params: payload.params });
  }

  getDocumentType(payload) {
    return this._httpClient.get(this.apiUrl + '/document-type/', {
      params: payload.params,
    });
  }
  assignDocumentType(payload) {
    return this._httpClient.post(
      this.apiUrl + `/object-document/${payload.optionId}`,
      payload.body
    );
  }
  unAssignDocumentType(payload) {
    return this._httpClient.delete(
      this.apiUrl +
        `/object-document/${payload.optionId}/${payload.documentTypeIds}`
    );
  }
  getAllAppUsersInOrganization(payload): Observable<any> {
    const url = `${this.apiUrl}/organizations/${payload.organizationId}/users/`;
    return this._httpClient.get(url, { params: payload.params });
  }

  updateWorkflow(payload): Observable<any> {
    const url = `${this.apiUrl}/collaborators/workflow/update-details/`;
    return this._httpClient.put(url, payload.body);
  }
  getAllOrganizationUnits(payload): Observable<any> {
    const url = `${this.apiUrl}/organization/${payload.organizationId}/units/`;
    return this._httpClient.get<any>(url, { params: payload.params });
  }

  createWorkflow(payload): Observable<any> {
    const url = `${this.apiUrl}/collaborators/${payload.organizationUnitId}/work_flows/`;
    return this._httpClient.post(url, payload.body);
  }

  getWorkflowUsers(workflowId, type, payload) {
    const url = this.users(workflowId, type);
    return this._httpClient.get(url, { params: payload.param });
  }

  assignOrUnassignWorkflowUsers(payload) {
    const url = `${this.apiUrl}/collaborators/${payload.organizationUnitId}/work_flows/${payload.workflowGroupId}/type/${payload.workflowType}/users/`;
    return this._httpClient.put(url, payload.body);
  }
  unassignOrUnassignWorkflowUsers(payload) {
    const url = `${this.apiUrl}/collaborators/${payload.organizationUnitId}/work_flows/${payload.workflowGroupId}/type/${payload.workflowType}/users/${payload.app_user_id}/`;
    return this._httpClient.delete(url, payload.body);
  }

  deactivateWorkflow(payload) {
    const url = `${this.apiUrl}/collaborators/${payload.organizationUnitId}/work_flows/${payload.workflowGroupId}/type/${payload.workflowType}/`;
    return this._httpClient.delete(url);
  }

  activateWorkflow(payload) {
    const url = `${this.apiUrl}/collaborators/${payload.organizationUnitId}/work_flows/${payload.workflowGroupId}/type/${payload.workflowType}/`;
    return this._httpClient.put(url, {});
  }

  workflowGraph(payload) {
    const url = `${this.apiUrl}/collaborators/${payload.organizationUnitId}/work_flows/${payload.workflowGroupId}/type/${payload.workflowType}/`;
    return this._httpClient.get(url);
  }

  unassignWorkflowUser(workflowId, type) {
    const url = this.users(workflowId, type);
    return this._httpClient.delete(url);
  }
}
